import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBasket, ArrowRight, MapPin, CalendarCheck } from "lucide-react";

const OrderBanner = () => {
  const navigate = useNavigate();
  return (
    <section data-testid="order-banner" id="commander" className="py-20 lg:py-24 bg-[#2C2A28]">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rounded-[2rem] bg-bordeaux text-white p-10 lg:p-14 text-center relative overflow-hidden"
        >
          <span className="inline-flex w-16 h-16 rounded-2xl bg-white/12 items-center justify-center mb-5">
            <ShoppingBasket size={30} />
          </span>
          <span className="block text-sm uppercase tracking-[0.3em] text-white/70 font-500">Campagne de commandes — Noël 2026</span>
          <h2 className="font-heading text-4xl sm:text-5xl mt-3 tracking-tight">Commander vos escargots</h2>
          <p className="text-lg text-white/85 mt-5 leading-relaxed max-w-2xl mx-auto">
            Préparez votre commande directement en ligne et choisissez votre point de retrait.
            Vous réglerez votre commande sur place lors du retrait.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-7 text-white/75 text-sm">
            <span className="inline-flex items-center gap-2"><MapPin size={16} /> Plusieurs points de retrait</span>
            <span className="inline-flex items-center gap-2"><CalendarCheck size={16} /> Vous choisissez votre date</span>
          </div>

          <button
            data-testid="order-banner-cta"
            onClick={() => navigate("/commander")}
            className="mt-9 inline-flex items-center gap-2 rounded-full bg-creme text-bordeaux font-600 text-lg px-9 py-4 hover:bg-white transition-all hover:-translate-y-0.5"
          >
            Commander maintenant <ArrowRight size={20} />
          </button>
          <p className="text-xs text-white/55 mt-4">Paiement sur place — aucun paiement en ligne</p>
        </motion.div>
      </div>
    </section>
  );
};

export default OrderBanner;
